import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { constants } from 'app/constants';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Utility } from 'app/utility';


@Injectable({
  providedIn: 'root'
})
export class AttributesService {

  attributesList: any;

  constructor(
    private http: HttpClient
  ) { }

  createForm(attributeFactorsTitleList: any) {
    return new UntypedFormGroup({
      'productGroupName': new UntypedFormControl('', Validators.required),
      'productAttr': new UntypedFormArray(
        this.createItem(attributeFactorsTitleList)
      )
    });
  }

  createItem(factorValuesList: any) {
    const attrFormArray = [];
    for (let i = 0; i < constants.ATTRIBUTES_COUNT; i++) {
      const factorControls: any = {};
      for (let j = 0; j < factorValuesList.length; j++) {
        factorControls[factorValuesList[j]] = new UntypedFormControl('');
      }
      attrFormArray.push(new UntypedFormGroup(factorControls));
    }
    return attrFormArray;
  }

  addUpdateAttributesApi(attributesForm: any, selectedProductGroupData: any, requestMethod: string, data: any = {}) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'attribute/';

      if (requestMethod !== 'DELETE') {
        data = this.getDataFromForm(attributesForm, selectedProductGroupData, data);
      }
      if (!data) {
        return reject();
      }
      this.http.request(requestMethod, endpointUrl, {body: data})
      .subscribe(
        response => {
          console.log('Attributes Addeddd......');
          if (response) {
            this.addAttributesNameForGrid(response);
          }
          resolve(response);
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  getDataFromForm(attributesForm: any, selectedProductGroupData: any, data: any) {
    const attrData = this.getAttributesData(attributesForm);
    if (!attrData) {
      return undefined;
    }
    data['attributes_json_data'] = JSON.stringify(attrData);
    data['user_id'] = sessionStorage.getItem('user_id');
    data['product_grp_id'] = selectedProductGroupData['id'];
    data['product_grp_name'] = selectedProductGroupData['product_grp_name'];
    this.addAttributesNameForGrid(data);
    return data;
  }

  getAttributesData(attributesForm: any) {
    const prodAttributes = attributesForm.get('productAttr')?.value;
    if (prodAttributes.length === 0) {
      alert('Product Attributes Null. Something went wrong!');
      return undefined;
    }

    const prodAttributesList = [];
    for (let i = 0; i < constants.ATTRIBUTES_COUNT; i++) {
      const attribute = prodAttributes[i];
      const name = attribute[constants.ATTRIBUTE_FACTORS[0]];
      if (!name) {
        break;
      }
      let option = attribute[constants.ATTRIBUTE_FACTORS[1]];
      if (!option) {
        alert('Product Options Null. Something went wrong!');
        return undefined;
      }
      option = option.replace(/ /g, "");
      prodAttributesList.push({name : name, options: option});
    }

    return {attributes: prodAttributesList};
  }

  getAllAttributesApi() {
    return new Promise((resolve, reject) => {
      if (this.attributesList) {
        resolve(this.attributesList);
        return;
      }
      const endpointUrl = environment.host_api + 'attribute/';
      this.http.request('GET', endpointUrl, {})
      .subscribe(
        response => {
          if (response) {
            console.log('All Attributes Received......');
            this.addAttributesNameForGrid(response);
            this.attributesList = response;
            resolve(response);
          }
        },
        error => {
          console.log(error.error);
          reject(error.error)
        }
      );
    });
  }

  addAttributesNameForGrid(data: any) {
    if (!Array.isArray(data)) {
      this.addEachAttributesNameForGrid(data);
      return;
    }
    for (let i = 0; i < data.length; i++) {
      this.addEachAttributesNameForGrid(data[i]);
    }
  }

  addEachAttributesNameForGrid(jsonData: any) {
    const attributesList = (JSON.parse(jsonData['attributes_json_data']))['attributes'];
    let attributesName = [];
    for (let i = 0; i < attributesList.length; i++) {
      const name = attributesList[i]['name'];
      attributesName.push(name);
    }
    jsonData['attributes_name'] = attributesName.join(',');
  }

  getAttributesNameFromSelectedData(selectedData: any) {
    const attributeJson = JSON.parse(selectedData['attributes_json_data']);
    return attributeJson['attributes'];
  }

  updateAttributesDataToList(attributesData: any) {
    const attributes = JSON.parse(attributesData['attributes_json_data'])['attributes'];
    for (let i = 0; i < attributes.length; i++) {
      attributes[i]['options'] = attributes[i]['options'].split(',');
    }
    return attributes;
  }

  updateAndPopulateAttributesDropdownOptions(allAttributesList: any, selectedProductGroupId: Number) {
    const attributesList = Utility.updateListByProdGroupId(allAttributesList, selectedProductGroupId)[0];
    if (!attributesList) { return []; }
    return this.updateAttributesDataToList(attributesList);
  }
}
